function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0002 61.4001C32.1002 61.4001 25.7002 55.0001 25.7002 47.1001C25.7002 44.9001 26.3002 42.9001 27.1002 41.2001L27.9002 39.5001L40.0002 18.6001L51.9002 39.3001C52.9002 41.1001 54.2002 44.0001 54.2002 47.1001C54.3002 55.0001 47.9002 61.4001 40.0002 61.4001ZM29.9002 40.5001L29.8002 40.6001C28.8002 42.5001 27.9002 44.7001 27.9002 47.1001C27.9002 53.7001 33.3002 59.1001 39.9002 59.1001C46.5002 59.1001 51.9002 53.7001 51.9002 47.1001C51.9002 44.5001 50.8002 42.2001 49.9002 40.4001L39.9002 23.1001L29.9002 40.5001Z",
  fill: "#BAA273"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40 3C60.4 3 77 19.6 77 40C77 60.4 60.4 77 40 77C19.6 77 3 60.4 3 40C3 19.6 19.6 3 40 3ZM40 0C17.9 0 0 17.9 0 40C0 62.1 17.9 80 40 80C62.1 80 80 62.1 80 40C80 17.9 62.1 0 40 0Z",
  fill: "#BAA273"
});

var SvgWaterNone = function SvgWaterNone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaterNone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/water-none.9ad9b02e.svg";
export { ForwardRef as ReactComponent };